import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiQueries, DiaryEntryType, DaymapDialog } from "daymap-react";
import { Box } from "@mui/material";
import { SlotSummary } from "daymap-react";

type DiaryItemModalProps = {
    interviewSlotId?: number;
    groupId?: number;
    studentId?: number;
    staffId?: number;
    classId?: number;
}

const DiaryItemModal: React.FC<DiaryItemModalProps & { onClose: () => void }> = ({ interviewSlotId, groupId, studentId, staffId, classId, onClose }) => {
    if (interviewSlotId)
        return <DaymapDialog open onClose={onClose}>
            <Box p={2}>
                <SlotSummary slotId={interviewSlotId} groupId={groupId} studentId={studentId} staffId={staffId} classId={classId} />
            </Box>
        </DaymapDialog>

    return null;
}

export interface UseDiaryItemClickOptions {
    onNavigate?: (url: string) => void;
}

export const useDiaryItemClick = (options?: UseDiaryItemClickOptions) => {
    const navigate = useNavigate();
    const [modalProps, setModalProps] = useState<DiaryItemModalProps>();

    const handleItemClick = (item: ApiQueries.calendars.DiaryItem) => {
        let url = '';
        
        switch (item.Type) {
            case DiaryEntryType.Lesson:
            case DiaryEntryType.CalendarEvent:
                if (!item.RecordID)
                    url = `/student/${item.StudentID}/timetable/${item.ID}`;
                else
                    url = `/student/${item.StudentID}/excursion/${item.ID}?formId=${item.FormID}&rowId=${item.RecordID}`;
                break;
            case DiaryEntryType.Interview:
                setModalProps({
                    interviewSlotId: item.ID,
                    groupId: item.GroupID,
                    studentId: item.StudentID,
                    staffId: item.Staff?.[0]?.ID,
                    classId: item.ClassID
                });
                break;
            case DiaryEntryType.Task:
                url = `/student/${item.StudentID}/assessment/${item.ID}`;
                break;
            default:
                break;
        }

        if (url) {
            if (options?.onNavigate) {
                options.onNavigate(url);
            }
            navigate(url);
        }
    };

    const modalElement = modalProps ? (
        <DiaryItemModal {...modalProps} onClose={() => setModalProps(undefined)} />
    ) : null;

    return {
        handleItemClick,
        modalElement
    };
};
